export default function Header() {
  return (
    <>
      <div className="header">
        <h1>
          <span>HangmAn</span>imals 🐯
        </h1>
        <p>Challenge your instincts guessing the animal name!</p>
      </div>
    </>
  );
}
